import { render, staticRenderFns } from "./AdminQuestionsBank.vue?vue&type=template&id=e8423658&scoped=true"
import script from "./AdminQuestionsBank.vue?vue&type=script&lang=js"
export * from "./AdminQuestionsBank.vue?vue&type=script&lang=js"
import style0 from "./AdminQuestionsBank.vue?vue&type=style&index=0&id=e8423658&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8423658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8423658')) {
      api.createRecord('e8423658', component.options)
    } else {
      api.reload('e8423658', component.options)
    }
    module.hot.accept("./AdminQuestionsBank.vue?vue&type=template&id=e8423658&scoped=true", function () {
      api.rerender('e8423658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminQuestionsBank.vue"
export default component.exports